import { Action } from 'redux';

export interface ProducerProspectPaginatorStateStructure {
  pageIndex: number;
  pageSize: number;
  totalLength?: number;
}

const INITIAL_STATE_STRUCTURE: ProducerProspectPaginatorStateStructure = {
  pageIndex: 0,
  pageSize: null,
  totalLength: 0
};

/** ACTION CLASS */
export class ProducerProspectPaginatorAction implements Action {
  type: string;
  pageIndex?: number;
  pageSize?: number;
  totalLength?: number;
}

/** ACTIONS TYPES */
const RESET_CURRENT_PAGE = 'RESET_CURRENT_PAGE';
const SET_CURRENT_PAGE = 'SET_CURRENT_PAGE';
const SET_TOTAL_LENGTH = 'SET_TOTAL_LENGTH';

/** ACTIONS */
export function resetPageIndex(): ProducerProspectPaginatorAction {
  return { type: RESET_CURRENT_PAGE };
}
export function setPaginationData(pageIndex: number, pageSize: number): ProducerProspectPaginatorAction {
  return { type: SET_CURRENT_PAGE, pageIndex, pageSize };
}
export function setTotalLength(totalLength: number): ProducerProspectPaginatorAction {
  return { type: SET_TOTAL_LENGTH, totalLength };
}
export const PRODUCER_PROSPECT_PAGINATOR_REDUCER_NAME = 'PLAN_SUMMARY_LIST_PAGINATOR';
export function ProducerProspectPaginator(
  state: ProducerProspectPaginatorStateStructure = INITIAL_STATE_STRUCTURE,
  action: ProducerProspectPaginatorAction
) {

  const copiedState: ProducerProspectPaginatorStateStructure = JSON.parse(JSON.stringify(Object.assign({}, state)));

  switch (action.type) {

    case SET_CURRENT_PAGE:
      copiedState.pageIndex = action.pageIndex;
      copiedState.pageSize = action.pageSize;
      return Object.assign({}, state, copiedState);

    case RESET_CURRENT_PAGE:
      return Object.assign({}, state, INITIAL_STATE_STRUCTURE);

    case SET_TOTAL_LENGTH:
      copiedState.totalLength = action.totalLength || 0;
      return Object.assign({}, state, copiedState);

    default:
      return state;

  }
}
